// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"MainHeader_toolbar__1AuNR","companiesDropdownBtn":"MainHeader_companiesDropdownBtn__3PnJO","btnText":"MainHeader_btnText__ohzuj"};